<template>
	<div class="Mycell">

		<div v-for="(dataitem, index) in tableData" :key="index" style="margin-bottom: 1rem;margin: 1rem;">

			<van-swipe-cell :ref="`swipeCell${index}`" @click="onCellClick(index)" @open="open(index)" @close="close(index)">
				<van-cell-group>
					<!-- 第一行：显示 table_label.slice(1, 3) -->
					<van-cell is-link>
						<template #title>
							<div class="cell-title-row">
								<div v-for="(labelitem, idx) in displayedLabels" :key="idx" class="strong">
									{{ labelitem.label }}: {{ dataitem[labelitem.value] || '--' }}
								</div>
							</div>
						</template>
						<!-- 自定义右侧：根据状态显示左或右箭头 -->
						<template #right-icon>
							<van-icon :name="arrowDirections[index] === 'left' ? 'arrow-left' : 'arrow'"
								@click.stop="onFeedback(index)" />
						</template>
					</van-cell>

					<!-- 第二行：自动适应的剩余字段 -->
					<van-cell>
						<template #title>
							<div class="cell-title-row wrap">
								<div v-for="(labelitem, idx) in displayedLabels2" :key="idx" class="title-item"
									v-if="labelitem.value !== 'img' && formatValue(dataitem, labelitem) &&labelitem.value !== 'dir' &&labelitem.value !== 'history' ">
									<span>{{ labelitem.label }}:</span>
									<span v-if="formatValue(dataitem, labelitem)"
										:style="{ color: getTextColor(dataitem, labelitem) }">{{ formatValue(dataitem, labelitem) }}</span>
								</div>

								<div v-else-if="dataitem.dir!='' && labelitem.value=='dir' " style="display:flex;">
									<el-image class="imagestyle" :src="dataitem.dir" :preview-src-list="[dataitem.dir]">></el-image>
								</div>
								<!-- <div v-else-if="dataitem.img!=''  && labelitem.value=='img' " style="display:flex;">
									<el-image class="imagestyle" :src="dataitem" :preview-src-list="[dataitem.img]"></el-image>
								</div> -->
							</div>
						</template>
					</van-cell>
				</van-cell-group>
				<template #right>
					<!-- 合同换房、换人 -->
					<div v-if="name=='contract'">
						<van-button class="Mycellitem" type="info" square text="合同换房" @click="Edit(dataitem,'合同换房')" />
						<van-button class="Mycellitem" type="primary " square text="合同换人" @click="Edit(dataitem,'合同换人')" />
					</div>
					<!-- 账单管理 -->
					<div v-if="name=='orders'||name == 'bills'">
						<van-button class="Mycellitem" :disabled="dataitem.pay_status=='已支付'" square type="primary" text="后台支付"
							@click="BannerStatus(dataitem,'后台支付',index)" />
					</div>
					<!-- 智能水电表 -->
					<div v-if="name=='Intelligent_devices'">
						<van-button class="Mycellitem" square type="info" text="历史" @click="Viewhistory(dataitem)" />
						<van-button class="Mycellitem" plain hairline type="default" text="充值" @click="lockinit(dataitem)" />
					</div>
					<!-- 绑定房间 -->
					<div v-if="name=='Lock' || name=='Intelligent_devices'">
						<van-button class="Mycellitem" type="primary" text="绑定房间" @click="roominit(dataitem)" />
					</div>
					<div v-if="name=='Lock'">
						<van-button class="Mycellitem" type="default" square text="重置密码" @click="lockinit(dataitem)" />
					</div>
					<!-- 绑定公众号、修改密码 -->
					<div v-if="name=='administrator'">
						<van-button class="Mycellitem" plain hairline type="primary" text="修改密码" @click="lockinit(dataitem)" />
						<van-button class="Mycellitem" square type="primary" text="绑定公众号" @click="getimage(dataitem)" />
					</div>
					<!-- 发送消息 -->
					<div v-if="name=='orders'">
						<van-button class="Mycellitem" plain hairline type="primary" text="发送提醒" @click="BannerStatus(dataitem)" />
					</div>

					<!-- 常规 -->
					<div v-if="changguicaozuo">
						<van-button class="Mycellitem" v-if="bianjiButtonVisible" square type="info" @click="Edit(dataitem)">
							{{ bianjiReviewMode ?'审核':'编辑'}}
						</van-button>
						<van-button v-if="shanchuButtonVisible" class="Mycellitem" square type="danger" text="删除"
							@click="Delete(dataitem,index)" />

					</div>


				</template>
			</van-swipe-cell>

		</div>
		<van-empty v-if="tableData.length<=0" description="暂无数据" />
		<div class="pagination" v-if="name!='Intelligent_devices'">
			<el-pagination background layout="prev, pager, next" :total="total" :hide-on-single-page="total<15"
				@current-change="Currentchange" :page-size="15" :current-page="page?page:1" :pager-count='5'>
			</el-pagination>
		</div>
		<button v-show="isVisible" class="back-to-top" @click="backToTop" aria-label="回到顶部">
			<i class="el-icon-arrow-up"></i>
		</button>
	</div>
</template>

<script>
	export default {
		props: [
			'tableData',
			'table_label',
			'name',
			'total',
			'page'
		],
		data() {
			return {
				tableHeight: 0,
				activeNames: [],
				arrowDirections: [],
				isVisible: false
			}
		},
		methods: {

			formatValue(dataitem, labelitem) {
				const fieldKey = labelitem.value; // 如 'status'
				const fieldValue = dataitem[fieldKey];
				const fieldName = this.name; // 如 'user'
				// console.log('fieldValue:', fieldValue);

				// 示例：只有在 user 页面时，才特殊处理 status 字段
				if (fieldName === 'user' && fieldKey === 'status') {
					const map = {
						1: '启用',
						2: '禁用'
					};
					return map[fieldValue] || '禁用';

				}
				if (fieldName === 'administrator') {
					if (fieldKey === 'status') {
						const map = {
							1: '启用',
							2: '禁用'
						};
						return map[fieldValue] || '禁用';
					}
					if (fieldKey === 'ismsg') {
						const map = {
							1: '是',
							0: '否'
						};
						return map[fieldValue];
					}
					if (fieldKey === 'wxopenid') {
						const falsy = [null, undefined, '', '0', 0, 'false', false];
						return falsy.includes(fieldValue) ? '否' : '是';
					}
				}
				if (fieldName === 'Intelligent_devices') {
					if (fieldKey === 'valve_status') {
						const map = {
							'open': '启用',
							'close': '禁用'
						};
						return map[fieldValue] || '禁用';
					}
				}
				// 其他字段或页面：直接返回原值
				if (
					fieldValue === null ||
					fieldValue === undefined ||
					fieldValue === '' ||
					fieldValue === 'null' || // 常见字符串
					fieldValue === 'undefined' ||
					(typeof fieldValue === 'string' && fieldValue.trim() === '') ||
					(Array.isArray(fieldValue) && fieldValue.length === 0) ||
					(typeof fieldValue === 'object' && fieldValue !== null && Object.keys(fieldValue).length === 0)
				) {
					return '无';
				}

				return fieldValue;
			},
			getTextColor(dataitem, labelitem) {
				const value = this.formatValue(dataitem, labelitem);
				const fieldName = this.name;
				// console.log('this.formatValue(dataitem, labelitem)：', labelitem.value);
				// 只在 user 页面对 "启用"/"禁用" 生效
				if (fieldName === 'user') {
					if (value === '启用') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '禁用') {
						return '#ee0a24'; // Vant 红色 danger
					} else if (value === '否') {
						return '#FAAB0C';
					} else if (value === '是') {
						return '#07c160';
					}
				}

				if (fieldName === 'repair') {
					if (value === '已维修') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '待处理') {
						return '#ee0a24'; // Vant 红色 danger
					} else if (value === '维修中') {
						return '#FAAB0C';
					}
				}
				if (fieldName === 'contract') {
					if (value === '有效') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '失效') {
						return '#ee0a24'; // Vant 红色 danger
					} else if (value === '维修中') {
						return '#FAAB0C';
					} else if (labelitem.value === 'day' && value < 30) {
						return '#ee0a24';
					} else if (labelitem.value === 'day' && value > 30) {
						return '#07c160';
					}
				}

				if (fieldName === 'renew' || fieldName === 'surrender') {
					if (value === '通过') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '拒绝') {
						return '#ee0a24'; // Vant 红色 danger
					} else if (value === '审核中') {
						return '#FAAB0C';
					}

				}

				if (fieldName === 'bills') {
					if (value === '已支付') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '待支付') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'devicelist') {
					if (value === '正常') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '异常') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'Lock') {
					if (value === '已出租') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '未出租') {
						return '#FAAB0C';
					} else if (labelitem.value === 'electricQuantity' && value < 30) {
						return '#ee0a24';
					} else if (labelitem.value === 'electricQuantity' && value > 30) {
						return '#07c160';
					} else if (labelitem.value === 'hasGateway' && value == '否') {
						return '#ee0a24';
					} else if (labelitem.value === 'hasGateway' && value == '是') {
						return '#07c160';
					}
				}

				if (fieldName === 'room') {
					if (value === '已发布' || value === '已出租') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '未发布' || value === '未出租') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'password') {
					if (value === '修改成功') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '修改失败') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'administrator') {
					if (value === '是' || value === '启用') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '否' || value === '禁用') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'carousel') {
					if (value === '有效') {
						return '#07c160'; // Vant 绿色 success
					} else {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'orders') {
					if (value === '已支付') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '待支付') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'terms') {
					if (value === '有效') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '过期') {
						return '#FAAB0C';
					}
				}

				if (fieldName === 'Intelligent_devices') {
					if (value === '在线' || value === '启用') {
						return '#07c160'; // Vant 绿色 success
					} else if (value === '过期' || value === '禁用') {
						return '#FAAB0C';
					}
				}

				// 其他情况返回默认颜色
				return '#333'; // 或 null 使用默认文本色
			},
			onCellClick(index) {
				const swipeCell = this.$refs[`swipeCell${index}`];
				if (!swipeCell || !swipeCell[0]) return;

				const isOpen = this.arrowDirections[index] === 'left';

				if (isOpen) {
					swipeCell[0].close();

				} else {
					swipeCell[0].open('right');
					this.$set(this.arrowDirections, index, 'left'); // 打开
				}
			},
			onFeedback(index) {
				// console.log('changguicaozuo:', this.changguicaozuo);
				if (!this.changguicaozuo && this.name != 'bills') {
					return
				}

				const swipeCell = this.$refs[`swipeCell${index}`];
				if (!swipeCell || !swipeCell[0]) return;

				const isOpen = this.arrowDirections[index] === 'left';

				if (isOpen) {
					swipeCell[0].open('right');
					this.$set(this.arrowDirections, index, 'right'); // 打开
				} else {

					swipeCell[0].close();
					this.$set(this.arrowDirections, index, 'left'); // 关闭
				}
			},
			open(index) {
				this.$set(this.arrowDirections, index, 'right');
			},
			close(index) {
				this.$set(this.arrowDirections, index, 'left');
			},
			handleSelectionChange(val) {
				const multipleSelection = []
				// 取出 id 字段
				val.forEach(item => {
					const id = item.id
					// 判断数组中是否包含这个 id 
					if (multipleSelection.indexOf(id) == -1) {
						multipleSelection.push(`${id}`)
					}
				})
				this.$emit("BatchDeleteValue", multipleSelection)
			},
			fontcolor(value) {
				// console.log('fontcolor:', value);
				if (value.status == '有效' || value.is_use == '是' || value.status == '在租' || value.status == '同意' || value
					.pay_status == '已支付' || value
					.status == '已出租' ||
					value.is_success == '修改成功' ||
					value.workstatus == '正常' || value.status == '在线' || value.status == '通过' || value.wxopenid == '是' || value
					.repairstatus == '已维修' || value
					.pwdType == '长期') {
					return {
						color: "#1bad1a"
					}
				} else if (value.status == '过期' || value.status == '已退租' || value.status == '拒绝' ||
					value.is_success == '修改失败' || value.status == '离线' || value
					.repairstatus == '待处理' || value
					.pwdType == '临时') {
					return {
						color: "#eb3941"
					}
				} else if (value.pay_type == '在线支付' || value.is_use == '否' || value
					.pay_status == '待支付' || value.status == '未出租' ||
					value.workstatus == '异常' || value.status == '审核中' || value.wxopenid == '否' || value
					.repairstatus == '维修中') {
					return {
						color: "#F29900"
					}
				}
			},
			scope_row(i, v) {
				if (i.is_use === 0) {
					i.is_use = '否'
				} else if (i.is_use === 1) {
					i.is_use = '是'
				} else if (i.sex === 1) {
					i.sex = '男'
				} else if (i.sex === 2) {
					i.sex = '女'
				}
				return i[v]
			},
			scope_row2(i, v) {
				if (i.status === 0) {
					i.status = '过期'
				} else if (i.status === 1) {
					i.status = '有效'
				} else if (i.type === 1 && this.name == 'contract') {
					i.type = '月度交租'
				} else if (i.type === 2 && this.name == 'contract') {
					i.type = '季度交租'
				} else if (i.type === 1 && this.name != 'contract') {
					i.type = '月度交租'
					if (i.status === '过期') {
						i.status = '审核中'
					} else if (i.status === '有效') {
						i.status = '通过'
					} else if (i.status === 2) {
						i.status = '拒绝'
					}
				} else if (i.type === 2 && this.name != 'contract') {
					i.type = '季度交租'
					if (i.status === '过期') {
						i.status = '审核中'
					} else if (i.status === '有效') {
						i.status = '通过'
					} else if (i.status === 2) {
						i.status = '拒绝'
					}
				} else if (this.name == 'surrender') {
					if (i.status === '过期') {
						i.status = '审核中'
					} else if (i.status === '有效') {
						i.status = '通过'
					} else if (i.status === 2) {
						i.status = '拒绝'
					}
				} else if (i.pay_status === 1) {
					i.pay_status = '已支付'
				} else if (i.pay_status === 0) {
					i.pay_status = '待支付'
				} else if (this.name == 'Lock') {
					if (i.status === '过期') {
						i.status = '未出租'
					} else if (i.status === '有效') {
						i.status = '已出租'
					}
				} else if (this.name === 'orders') {
					if (i.type == 1) {
						i.type = '水费'
					} else if (i.type == 2) {
						i.type = '电费'
					} else if (i.type == 3) {
						i.type = '房租'
					} else if (i.type == 4) {
						i.type = '押金差额'
					} else if (i.pay_type == 1) {
						i.pay_type = '小程序支付'
					} else if (i.pay_type == 2) {
						i.pay_type = '线下支付'
					}
				} else if (this.name == 'room') {
					if (i.status === '有效') {
						i.status = '已出租'
					} else if (i.status === '过期') {
						i.status = '未出租'
					} else if (i.publish === 0) {
						i.publish = '未发布'
					} else if (i.publish === 1) {
						i.publish = '已发布'
					}
				} else if (this.name == 'Intelligent_devices') {
					if (i.status === 'offline') {
						i.status = '离线'
					} else if (i.status === 'online') {
						i.status = '在线'
					}
				} else if (i.is_success == 1) {
					i.is_success = '修改成功'
				} else if (i.is_success == 0) {
					i.is_success = '修改失败'
				} else if (i.workstatus === 0) {
					i.workstatus = '正常'
				} else if (i.workstatus === 2) {
					i.workstatus = '异常'
				} else if (i.hasGateway === 1) {
					i.hasGateway = '是'
				} else if (i.hasGateway === 0) {
					i.hasGateway = '否'
				} else if (i.isbind != '' || i.isbind != null) {
					i.isbind = '是'
				} else if (i.isbind == '' || i.isbind == null) {
					i.isbind = '否'
				}
				return i[v]
			},
			//设置单元格
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				return 'height:40px!important; border-color:#f2f3f5!important; color:#000000!important; padding:0px!important;border-width: 2px !important;'
			},
			customHeaderStyle({
				column
			}) {},
			// 状态开关
			SwitchStatus(value) {
				// console.log('SwitchStatus', value);

				this.$confirm('是否确认此操作, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true,
					customClass: 'my-confirm-dialog'
				}).then(() => {
					this.$emit('SwitchStatus', value)
				}).catch(() => {

					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			},
			// 点击编辑
			Edit(value, title) {
				this.$emit("Edit", value, title)
			},
			// 点击删除
			Delete(value, index) {

				this.$confirm('此操作将永久删除该选项, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
					center: true,
					customClass: 'my-confirm-dialog'
				}).then(() => {
					this.$emit("Delete", value)
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
					const swipeCell = this.$refs[`swipeCell${index}`];
					swipeCell[0].open('right');
					// if (swipeCell && swipeCell[0] && swipeCell[0].close) {
					// swipeCell[0].close();
					// }
				});

				// this.$refs.swipeCell.close()
			},
			// 分页事件
			Currentchange(value) {
				this.$emit("Currentchange", value)
			},
			// 动态宽度
			getWidth(item) {
				if (this.name === 'user' || this.name === 'contract' || this.name === 'Intelligent_ViewHistory' ||
					this.name === 'operation_log') {
					switch (item.label) {
						case 'ID':
							return 40;
						case '姓名':
							return 80;
						case '房间编号':
							return 80;
						case '身份证号':
							return 180;
						case '电话':
							return 180;
						case '当前剩余':
							return 80;
						case '当前累计':
							return 80;
						case '当前读数':
							return 80;
						case '绑定小程序':
							return 80;
						case '绑定公众号':
							return 80;
						case '详情':
							return 340;
						case '操作时间':
							return 200;
						default:
							return '';
					}
				} else {
					// 默认宽度或其他情况下的宽度设置
					return '';
				}
			},
			BannerStatus(value, name, index) {
				if (name == '后台支付') {
					this.$confirm(`确定给${value.room_num}的${value.type}进行后台支付吗？`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
						center: true,
						customClass: 'my-confirm-dialog'
					}).then(() => {
						this.$emit("BannerStatus", value, name)

					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
						const swipeCell = this.$refs[`swipeCell${index}`];
						swipeCell[0].open('right');
					});
				} else {
					this.$emit("BannerStatus", value)
				}

			},
			lockinit(value) {
				this.$emit("lockinit", value)
			},
			//历史查看
			Viewhistory(value) {
				this.$emit("ViewHistory", value)
			},
			// 绑定房间
			roominit(value) {
				this.$emit("roominit", value)
			},
			// 绑定公众号
			getimage(value) {
				this.$emit("getimage", value)
			},
			// 动态文字颜色
			getCellStyle(itemValue, row) {
				if (this.name == 'Lock') {
					if (itemValue == 'status') {
						if (row.status == '未出租') {
							return {
								color: "#F29900"
							}
						} else {
							return {
								color: "#1bad1a"
							}
						}
					}
				}

				const specialFields = ['status', 'pay_status', 'is_success', 'workstatus', 'is_use', 'wxopenid',
					'repairstatus'
				];
				if (specialFields.includes(itemValue)) {
					return this.fontcolor(row);
				}
				if (itemValue == 'openid') {
					if (row.openid == '否') {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				if (itemValue == 'day') {
					if (row.day <= 30) {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				if (itemValue == 'publish') {
					if (row.publish == '未发布') {
						return {
							color: "#F29900"
						}
					} else {
						return {
							color: "#1bad1a"
						}
					}
				}
				return {};
			},
			setTableHeight() {
				this.tableHeight = window.innerHeight * 0.66;
				// console.log('tableHeight:', this.tableHeight);
				return (this.tableHeight)
			},
			handleScroll() {
				const container = document.querySelector('.Mycell');
				if (!container) return;

				const scrollTop = container.scrollTop; // ✅ 获取内部滚动位置
				this.isVisible = scrollTop > 200;
			},

			backToTop() {
				const container = document.querySelector('.Mycell');
				if (container) {
					container.scrollTo({
						top: 0,
						behavior: 'smooth'
					});

				}
			}
		},
		computed: {
			columnWidth() {
				if (this.name === 'Lock') {
					return 260;
				} else if (this.name === 'orders') {
					return 340;
				} else if (this.name === 'administrator') {
					return 280;
				} else {
					return 172;
				}
			},
			changguiPaGe() {
				return ['kinds', 'coupon', 'user', 'repair', 'administrator'].includes(this.name);
			},
			bianjiButtonVisible() {
				return !['entry', 'password', 'Intelligent_devices', 'contract'].includes(this.name);

			},
			bianjiReviewMode() {
				return ['renew', 'surrender'].includes(this.name);
			},
			shanchuButtonVisible() {
				return !['parameters', 'terms', 'Metermanagement', 'Lock', 'Intelligent_devices'].includes(this.name);
			},
			changguicaozuo() {
				return !['bills', 'devicelist', 'Intelligent_ViewHistory', 'operation_log'].includes(this.name);
			},
			displayedLabels() {
				if (this.name === 'carousel') {
					return this.table_label.slice(0, 1);
				}
				// 如果 table_label 数量 ≤ 3，只显示前两个
				if (this.table_label.length <= 3) {
					return this.table_label.slice(1, 2);
				}
				// 否则你可以返回更多（比如 slice(1,3) 或其他逻辑）
				return this.table_label.slice(1, 3); // 或其他逻辑
			},
			displayedLabels2() {
				if (this.name === 'carousel') {
					return this.table_label.slice(1);
				}
				// 如果 table_label 数量 ≤ 3，只显示前两个
				if (this.table_label.length <= 3) {
					return this.table_label.slice(2);
				}
				// 否则你可以返回更多（比如 slice(1,3) 或其他逻辑）
				return this.table_label.slice(3) // 或其他逻辑
			}
		},
		mounted() {
			// 初始化所有行为 'right'

			this.setTableHeight();
			window.addEventListener('resize', this.setTableHeight);
			// ✅ 改为监听 .Mycell 的滚动
			const container = document.querySelector('.Mycell');
			if (container) {
				container.addEventListener('scroll', this.handleScroll);
			}

			// 页面加载时检查
			this.$nextTick(() => {
				this.handleScroll();
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.setTableHeight);
			const container = document.querySelector('.Mycell');
			if (container) {
				container.removeEventListener('scroll', this.handleScroll);
			}
		},
		watch: {
			tableData: {
				handler() {
					this.arrowDirections = this.tableData.map(() => 'left');

				},
				immediate: false
			}
		},
	}
</script>

<style scoped>
	.Mycell {
		height: 68%;

		overflow-y: auto;
		/* 内部滚动 */
		position: relative;
		/* 为 back-to-top 定位提供参考 */
	}

	.Mycellitem {
		width: 100%;
		margin-left: 4px;
	}

	.cell-title-row {
		display: flex;
		flex-wrap: wrap;
		/* 允许换行 */
		gap: 8px;
		/* 均匀间距，比 margin 更好 */
		align-items: center;
		width: 100%;
		min-height: 4rem;
	}

	.cell-title-row.wrap {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding: 4px 0;
		/* 关键：不要在这里加左右 padding */
		/* 避免使用 font-size: 0，它可能影响 input 或其他子元素 */
	}

	.title-item {
		font-size: 14px;
		color: #333;
		background-color: #f5f5f5;
		padding: 4px 8px;
		border-radius: 4px;
		white-space: nowrap;
		/* 关键：设置最小宽度，避免压缩 */
		flex-shrink: 0;
		/* 可选：设置最大宽度，避免过长 */
		max-width: 100%;
	}

	.strong {
		font-weight: bold;
		color: #000;
	}

	.back-to-top {
		position: fixed;
		bottom: 60px;
		right: 30px;
		width: 40px;
		height: 40px;
		/* 拉高一点，像水滴垂感 */
		background-color: rgba(149, 201, 255, 0.4);
		/* 使用带有透明度的颜色 */
		color: white;
		border: none;
		/* 圆角：顶部小，底部大，模拟水滴 */
		border-radius: 6px;
		font-size: 20px;
		cursor: pointer;
		box-shadow:
			0 4px 12px rgba(64, 158, 255, 0.2),
			/* 轻微的蓝色投影 */
			0 0 4px rgba(64, 158, 255, 0.1);
		opacity: 0;
		visibility: hidden;
		transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
		z-index: 999;

		/* 可选：加一个轻微的“水滴”动画 */
		transform-origin: center bottom;
	}

	/* 淡入时带轻微弹动效果 */
	.back-to-top:not(.fade-leave-active) {
		opacity: 1;
		visibility: visible;
		transform: scale(1);
	}

	/* 悬停效果：像水滴轻颤 */
	.back-to-top:hover {
		transform: scale(1.08);
		box-shadow:
			0 6px 16px rgba(64, 158, 255, 0.2),
			0 0 6px rgba(64, 158, 255, 0.1);
	}

	/* 点击时：像水滴被点中下压 */
	.back-to-top:active {
		transform: scale(0.95);
		box-shadow:
			0 2px 8px rgba(64, 158, 255, 0.1),
			0 0 4px rgba(64, 158, 255, 0.05);
	}

	/* 配合 v-show 实现淡入效果 */
	/* 	.back-to-top:not(.fade-leave-active) {
		opacity: 1;
		visibility: visible;
	} */
	.pagination {
		position: fixed;
		bottom: 0.25rem;
		background-color: #fff;
		width: 100%;
		left: 50%;
		/* 从页面左边缘偏移 50% */
		transform: translateX(-50%);
		/* 向左移动自身宽度的一半 */
		margin: 0.25rem 0px;
	}
</style>